import { Input } from 'antd';
import TagInput from '@/components/TagInput/TagInput';
import TreeSelectForm from './TreeSelectForm';
const { TextArea } = Input,
    InputForm = (props) => {
        let { setting = {}, updated, desc, en_name } = props;
        const disabled = updated !== 0;
        if (setting.type === 'textarea') {
            return <TextArea style={{ resize: 'none' }} placeholder={desc}></TextArea>;
        }
        if (setting.type === 'tag') {
            return <TagInput disabled={disabled} {...setting} placeholder={desc}></TagInput>;
        }
        if (en_name === 'org_id') {
            return TreeSelectForm(props);
        }
        return <Input disabled={disabled} placeholder={desc}></Input>;
    };
export default InputForm;
